import { supabase } from '../client'

export async function deleteAdmin(adminId: number) {
  const { data, error } = await supabase.from('admins').delete().match({ id: adminId })
  return { data, error }
}
